var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentacion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 7.00026V0.460309C12.9247 0.809525 13.7652 1.3514 14.465 2.0503L17.9492 5.53636C18.6486 6.23526 19.1909 7.07526 19.5402 8.00056H13.0002C12.448 8.00056 12.0004 7.55291 12.0004 7.00073L11.9999 7.00026ZM20 10.4849V18.9997C19.9967 21.7597 17.7599 23.9965 14.9999 23.9998H5.00012C2.24014 23.9965 0.00328122 21.7597 0 18.9997V5.00012C0.00328122 2.24014 2.24014 0.00328122 5.00012 0H9.51508C9.67821 0 9.83898 0.0131249 10.0002 0.023906V6.99979C10.0002 8.65681 11.3432 9.99976 13.0002 9.99976H19.9761C19.9869 10.1605 20 10.3218 20 10.4849ZM11.9999 19.0002C11.9999 18.448 11.5523 18.0003 11.0001 18.0003H5.99995C5.44777 18.0003 5.00012 18.448 5.00012 19.0002C5.00012 19.5523 5.44777 20 5.99995 20H11.0001C11.5523 20 11.9999 19.5523 11.9999 19.0002ZM14.9999 14.9999C14.9999 14.4477 14.5522 14 14 14H5.99995C5.44777 14 5.00012 14.4477 5.00012 14.9999C5.00012 15.5521 5.44777 15.9997 5.99995 15.9997H14C14.5522 15.9997 14.9999 15.5521 14.9999 14.9999Z",
    fill: "#223D51"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentacion);
export default __webpack_public_path__ + "static/media/documentacion.2a40b687f3b31068363d15f12a64edd9.svg";
export { ForwardRef as ReactComponent };